import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import AdvancedSelectFormik from "app/pages/.shared/form/AdvancedSelectFormik/AdvancedSelectFormik";
import { memo, useContext } from "react";
import PropTypes from "prop-types";
import AppGlobalsContext from "app/AppGlobalsContext";
import SmartDPInputSidePanelContent from "app/pages/SmartDP/Search/SDPSearchForm/SmartDPInputSidePanelContent";
import FloatingAdvancedSelectFormik from "app/pages/.shared/form/FloatingAdvancedSelectFormik/FloatingAdvancedSelectFormik";

const SmartDPSearchInput = props => {
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	if (isMobile) {
		return <SmartDPInputSidePanelContent {...props} />;
	}
	if (props?.isFloating) {
		return <FloatingAdvancedSelectFormik {...props} />;
	}
	return <AdvancedSelectFormik {...props} />;
};

SmartDPSearchInput.propTypes = {
	isFloating: PropTypes.bool,
};

export default memo(SmartDPSearchInput);
